.customRadio {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.customRadio input {
  display: none;
}

.customRadio .checkmark {
  width: 22px;
  height: 22px;
  border: 2px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
  border-radius: 50%;
  margin-right: 8px;
  position: relative;
}

.customRadio input:checked + .checkmark {
  border: 8px solid var(--color-primary);
}

.customRadio input:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ffffff;
}